module.exports = (fox) => {

	var _ = {
		getTranslation: function(alias) {
			var translation = {
				'proceed': fox.i18n.getTranslation('proceed', 'Proceed', 'dialog'),
				'cancel': fox.i18n.getTranslation('cancel', 'Cancel', 'dialog'),
				'secretTitle': fox.i18n.getTranslation('secretTitle', 'Enter secret password', 'dialog'),
				};
			return translation[alias] || '';
		}
	};

	fox.registerWidget('Security_Popup_Request', {
		configure() {
			this.registerOptions('', {
				contentTemplate: 'popup_security_request',
				onOkPress: (...args) => this.onCancel(),
				dialog: {
					width: '390px',
					close: () => this.onCancel(),
					title: 'Password request submitted!',
					buttons: [{
						text: 'Got It!',
						click: function () {},
						class: 'mc-btn btn-small btn-casual',
						id: 'on-success'
					}],
				},
			}),

			this.callParent('configure', arguments);
		},
		onCancel() {
			this.securityData = fox.site.wom1('~.Security_Data');
			this.securityData.dispatchEvent('cancelPopup');
			this.hide();

			return fox.Promise.resolve(false);
		}
	}, 'GDPR_BasePopup');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/security-payment-details/widget/requestPopup.es.js